import React, {useState} from "react"
import CardTextModal from "../CardTextModal";

export default function GroupGameTableRowCell(props) {
    const [modalOpened, setModalOpened] = useState(false)
    const selectedPlayer = getSelectedPlayerData(props.selectedPlayerId)
    const userStepCells = new Set(selectedPlayer.steps.filter((step) => step.type === "step").map(step => step.to_position))



    function openModal() {
        if (props.gameState.role === "mentor" || selectedPlayer.player_settings.game_view_enable_view_all_cells || userStepCells.has(props.cellNumber)) {
            setModalOpened(true)
        }
    }

    function closeModal() {
        setModalOpened(false)
    }

    function GetContainerStyle() {
        return Object.assign({
            border: props.fieldStyle.cell_border
        })
    }

    function getSelectedPlayerData(playerId) {
        for (const player of props.gameState.players) {
            if (player.id === playerId) {
                return player
            }
        }
    }

    function GetCellStyle() {
        return Object.assign({
            display: "flex",
            width: props.fieldStyle.cell_width,
            height: props.fieldStyle.cell_height,
            flexDirection: "column",
            justifyContent: props.fieldStyle.cell_justify_content,
            alignItems: "stretch",
            color: props.fieldStyle.font_color,
            fontWeight: "bold",
            fontSize: props.fieldStyle.font_size,
            paddingLeft: "2px",
            paddingRight: "2px",
            paddingBottom: "2px",
            boxShadow : userStepCells.has(props.cellNumber) && selectedPlayer.player_settings.game_view_highlight_steps ? "inset 0px 0px 8px 4px white" : "",
            cursor: (props.gameState.role === "mentor" || selectedPlayer.player_settings.game_view_enable_view_all_cells || userStepCells.has(props.cellNumber)) ? "pointer" : "default"
        })
    }

    function GetTextStyle() {
        return Object.assign({
            verticalAlign: "bottom",
            textAlign: "center",
            alignSelf: "stretch",
            marginBottom: props.fieldStyle.text_margin_bottom,
            textShadow: props.fieldStyle.font_shadow
        })
    }

    function GetCellNumberStyle() {
        return Object.assign({
            fontSize: props.fieldStyle.cell_number_font_size,
            color: props.fieldStyle.cell_number_font_color,
            paddingLeft: "5px",
            paddingTop: "5px",
            textShadow: props.fieldStyle.font_shadow,
            marginBottom: "unset"
        })
    }

    return (
        <td style={new GetContainerStyle()}>
            <div style={new GetCellStyle()} onClick={openModal}>
                <p style={new GetCellNumberStyle()}>{props.cellNumber}</p>
                <div style={new GetTextStyle()} dangerouslySetInnerHTML={{__html: props.cellTitle}}/>
            </div>
            {
                modalOpened && <CardTextModal
                    modalOpened={modalOpened}
                    closeModal={closeModal}
                    cellNumber={props.cellNumber}
                    groupGame={true}
                />
            }
        </td>
    )

}